import {sendEvent, type SendEventContext} from '@github-ui/hydro-analytics'

import {
  DEFAULT_DEEP_LINK,
  getAcceptedDeepLinkScheme,
  isValidAcceptedDeepLink,
  type AcceptedDeepLinkScheme,
  type LaunchTrigger,
} from './deep-link'
import {COPILOT_APP_LAUNCHER_PATH} from './urls'

const ENTRY_POINT_MAX_LENGTH = 64
const ENTRY_POINT_PATTERN = new RegExp(`^[a-z0-9_.-]{1,${ENTRY_POINT_MAX_LENGTH}}$`)
const EVENT_PREFIX = 'copilot_app_launcher'

export type LauncherEntryPoint = string
export type LauncherTelemetryState = 'waiting' | 'success' | 'expired' | 'mobile_unsupported'
export type LauncherTelemetryTargetKind = 'accepted' | 'default' | 'invalid'
export type LauncherTelemetryScheme = AcceptedDeepLinkScheme | 'unsupported'
export type CopilotAppLauncherEventName =
  | 'viewed'
  | 'open_attempt'
  | 'open_manual'
  | 'download_clicked'
  | 'invalid_target'

export type CopilotAppLauncherTelemetryContext = SendEventContext & {
  entry_point: LauncherEntryPoint
  state: LauncherTelemetryState
  scheme: LauncherTelemetryScheme
  target_kind: LauncherTelemetryTargetKind
  trigger?: LaunchTrigger
}

export function sanitizeEntryPoint(entryPoint: string | null | undefined): LauncherEntryPoint {
  if (entryPoint === null || entryPoint === undefined || entryPoint === '') return 'unknown'
  return ENTRY_POINT_PATTERN.test(entryPoint) ? entryPoint : 'invalid'
}

export function getCopilotAppLauncherTargetTelemetry(
  target: string | null,
): Pick<CopilotAppLauncherTelemetryContext, 'scheme' | 'target_kind'> {
  if (!target) {
    return {scheme: getAcceptedDeepLinkScheme(DEFAULT_DEEP_LINK) ?? 'ghapp', target_kind: 'default'}
  }

  const scheme = getAcceptedDeepLinkScheme(target)
  if (scheme) {
    return {scheme, target_kind: isValidAcceptedDeepLink(target) ? 'accepted' : 'invalid'}
  }

  return {scheme: 'unsupported', target_kind: 'invalid'}
}

export function sendCopilotAppLauncherEvent(
  eventName: CopilotAppLauncherEventName,
  context: CopilotAppLauncherTelemetryContext,
) {
  sendEvent(`${EVENT_PREFIX}.${eventName}`, context, {page: COPILOT_APP_LAUNCHER_PATH})
}
